(function($) {

    'use strict';

    if(typeof KUP === 'undefined') {
        return null;
    }

    /**
     * HorizontalNavigation module
     *
     * @class KUP.HorizontalNavigation
     */
    var HorizontalNavigation = (function() {

        /**
         * Reference on the container
         *
         * @private
         * @property container
         * @type {Object}
         */
        var container = '.horizontal-navigation',

        /** Reference on the body for toggle css class
         *
         * @private
         * @property body
         * @type {Object}
         */
            body = $('body'),
        /**
         * Reference on the ul.menu of the navigation
         * for all and for each level
         *
         * @private
         * @property submenus, submenusLevel_0, submenusLevel_1, submenusLevel_2,
         * @type {Object}
         */
            submenus,
            submenusLevel_0,
            submenusLevel_1,
            submenusLevel_2,

        /** Reference on the li.menu-item of the navigation
         * for all, level 0 and 2
         *
         * @private
         * @property menuItems, menuItemsLevel_0, menuItemsLevel_2
         * @type {Object}
         */
            menuItems,
            menuItemsLevel_0,
            menuItemsLevel_2,

        /** Reference on the links of the navigation
         * for level 0 and 2
         *
         * @private
         * @property menuLinksLevel_0, menuLinksLevel_2
         * @type {Object}
         */
            menuLinksLevel_0,
            menuLinksLevel_2,

        /**
         * Event type
         *
         * @private
         * @property evtType
         * @type {String}
         */
            evtType = window.touch ? 'touchstart' : 'click',

        /**
         * Reference on the nav-button
         *
         * @private
         * @property navBtn
         * @type {Object}
         */
            navBtn = $('#pushmenu-button'),

        /**
         * CSS class for menu items if there is open
         *
         * @private
         * @property menuActiveClass
         * @type {String}
         */
            menuActiveClass = 'menu-is-active',

        /**
         * CSS class for body if menu is active
         *
         * @private
         * @property openClass
         * @type {String}
         */
            openClass = 'open';

        /**
         * Initialization of the module
         *
         * @method init
         */
        function init() {
            container = $(container);

            if ( container.length ) {
                submenus = container.find('ul.menu');
                submenusLevel_0 = container.find('ul.menu.menu-level-0');
                submenusLevel_1 = container.find('ul.menu.menu-level-1');
                submenusLevel_2 = container.find('ul.menu.menu-level-2');

                menuItems = container.find('li.menu-item');
                menuItemsLevel_0 = submenusLevel_0.children('li.menu-item');
                menuItemsLevel_2 = submenusLevel_2.children('li.menu-item');

                menuLinksLevel_0 = menuItemsLevel_0.children('a:not(:only-child)');
                menuLinksLevel_2 = menuItemsLevel_2.children('a');

                initListener();
            }
        }

        /**
         * Register Listener
         *
         * @private
         * @method initListener
         */
        function initListener() {

            toggleSubmenu();

            $(navBtn).on(evtType, function() {
                body.toggleClass(menuActiveClass);
                submenus.removeClass(openClass);
            });

            container.find('.menu-close-btn').on(evtType, function() {
                closeNavigation();
            });

            if ($(window).width() > 991){
                setSubmenuHeight();
            }

            // close navigation on resize, recalculate submenus height
            $(window).on('resize', function() {
                closeNavigation();
                setSubmenuHeight();
            });

            // reinitialize navigation
            $(window).on('resizeend', function() {
                toggleSubmenu();
            });
        }

        /**
         * Toggle open class for menu items of horizontal menu
         *
         * @method toggleSubmenu
         * @return {Null}
         */
        function toggleSubmenu() {

            // remove all eventhandlers
            menuLinksLevel_0.off(evtType);
            submenusLevel_1.off('mousemove');

            // add eventhanders (desktop hover and mousemove check, mobile click/touchstart)
            menuLinksLevel_0.on(evtType, function(e) {
                e.preventDefault();

                menuItemsLevel_0.not($(this).closest(menuItems)).removeClass(openClass);
                $(this).closest(menuItems).toggleClass(openClass);

                if ($(window).width() > 991) {
                    submenusLevel_1.on('mousemove', function(e) {
                        if(e.offsetY > $(this).outerHeight(true)) {
                            $(menuItems).removeClass(openClass);
                        }
                    });
                }
            });


            // to be removed later, for presentation only(no anchor-links in horizontal navigation)
            menuLinksLevel_2.on(evtType, function() {
                body.removeClass(menuActiveClass);
                menuItemsLevel_0.removeClass(openClass);
                submenus.removeClass(openClass);
            });
        }

        function setSubmenuHeight() {
            if ($(window).width() > 991) {
                $.each(submenusLevel_1, function() {
                    var dropdownMenu = $(this),
                        heightFirstLevel = dropdownMenu.outerHeight(true),
                        navBgHeight = heightFirstLevel;
                });
            }
        }

        function closeNavigation() {
            body.removeClass(menuActiveClass);
            menuItems.removeClass(openClass);
        }


        /**
         * @return Public-API
         */
        return {
            init: init
        };

    }());


    KUP.HorizontalNavigation = HorizontalNavigation;

    return HorizontalNavigation;

}(jQuery));
